import { styled } from "@mui/system";
import { Grid, Stack } from "@mui/material";

export const GridItem = styled(Grid)({
    position: "relative",
    cursor: "pointer",
});

export const OriginalAspectRatioImageContainer = styled(Stack, {
    shouldForwardProp: (prop) => prop !== "imageHeight",
})<{ imageHeight: string }>(({ imageHeight }) => ({
    img: {
        maxWidth: "100%",
        borderRadius: "4px",
        minHeight: imageHeight,
    },
}));

export const SquareAspectRatioImageContainer = styled(Stack)({
    img: {
        objectFit: "cover",
        aspectRatio: "1 / 1",
        width: "100%",
        borderRadius: "4px",
    },
});
